export default "__VITE_ASSET__Dq56LrA6__"